/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * 十八线_接口文档
 * 十八线——小众旅游
 * OpenAPI spec version: 版本号:0.0.1
 */
import type {
  AjaxResult,
  Export3Params,
  GetInfo15PathParameters,
  List4Params,
  Remove6Params,
  TableDataInfo,
  TravelDish
} from '../../../types/api';

import { orvalMutator } from '../../../utils/orval-mutator';



  export const get = () => {
/**
 * @summary 删除菜品
 */
const remove6 = (
    params: Remove6Params,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/dish/remove`, method: 'POST',
        params
    },
      );
    }
  /**
 * @summary 查询菜品列表
 */
const list4 = (
    params: List4Params,
 ) => {
      return orvalMutator<TableDataInfo>(
      {url: `/travel18/dish/list`, method: 'POST',
        params
    },
      );
    }
  /**
 * @summary 导出菜品列表
 */
const export3 = (
    params: Export3Params,
 ) => {
      return orvalMutator<void>(
      {url: `/travel18/dish/export`, method: 'POST',
        params
    },
      );
    }
  /**
 * @summary 修改保存菜品
 */
const editSave4 = (
    travelDish: TravelDish,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/dish/edit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: travelDish
    },
      );
    }
  /**
 * @summary 新增保存菜品
 */
const addSave5 = (
    travelDish: TravelDish,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/dish/add`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: travelDish
    },
      );
    }
  /**
 * @summary 获取菜品详情
 */
const getInfo15 = (
    { dishId }: GetInfo15PathParameters,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/dish/${dishId}`, method: 'GET'
    },
      );
    }
  return {remove6,list4,export3,editSave4,addSave5,getInfo15}};
export type Remove6Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['remove6']>>>
export type List4Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['list4']>>>
export type Export3Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['export3']>>>
export type EditSave4Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['editSave4']>>>
export type AddSave5Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['addSave5']>>>
export type GetInfo15Result = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['getInfo15']>>>
